module.exports = __webpack_public_path__ + "static/media/PM48.6efc2572.png";